import { render, staticRenderFns } from "./TransferNotesIcon.vue?vue&type=template&id=188f0180"
import script from "./TransferNotesIcon.vue?vue&type=script&lang=js"
export * from "./TransferNotesIcon.vue?vue&type=script&lang=js"
import style0 from "./TransferNotesIcon.vue?vue&type=style&index=0&id=188f0180&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports